import { TranslateService } from '@ngx-translate/core';
import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'src/app/helper/date-time/date-time';

@Pipe({
	name: 'chatDatetime',
})
export class ChatDatetimePipe implements PipeTransform {
	constructor(
		private translateService: TranslateService
	) {

	}
	transform(startedAt: string | Date): any {
		if (!startedAt) {
			return 'N/A';
		}
		const format = 'YYYY, MMM DD, H:mm';
		startedAt = DateTime.format(startedAt, format);
		const current = DateTime.format(null, format);
		const splitter = ',';
		const startedSplitted = startedAt.split(splitter);
		const endedSplitted = current.split(splitter);
		let result: Array<any> = startedAt.split(splitter);

		// tslint:disable-next-line: forin
		for (const key in startedSplitted) {
			if (!startedSplitted.hasOwnProperty(key)) {
				continue;
			}
			if (startedSplitted[key] !== endedSplitted[key]) {
				continue;
			}
			delete result[key];
		}
		if (result.length) {
			result = result.filter((item) => item.trim().length);
			return result.length ? result.join(',') :  this.translateService.instant('now');
		}
		return startedAt;
	}
}
